import type { Selectable } from 'kysely'
import z from 'zod'

export type MonthlyUsageEntity = {
  identifier: string
  month: Date
  type: 'public-user' | 'web-team-user' | 'agent-key'
  inputTokens: number
  outputTokens: number
  messages: number
}

export type MonthlyUsage = Selectable<MonthlyUsageEntity>

export const monthlyUsageSchema = z
  .object({
    identifier: z.string(),
    month: z.date(),
    type: z.enum(['public-user', 'web-team-user', 'agent-key']),
    inputTokens: z.number(),
    outputTokens: z.number(),
    messages: z.number(),
  })
  .meta({ id: 'monthly-usage' }) satisfies z.ZodType<MonthlyUsage>
